import { Injectable } from '@angular/core';
import { HttpClient, HttpHeaders } from '@angular/common/http';
import { Observable } from 'rxjs/Observable';
import { environment } from '../../environments/environment.prod';
import { map } from 'rxjs/operators';
import 'rxjs/add/operator/map';
@Injectable({
  providedIn: 'root'
})
export class GoogleService {
  //http://localhost:8180/api/google_calendar_list
  //url: any = 'http://localhost:8180'; 
  //url: any = 'https://5.183.8.170:3004'; 
  url: any = 'https://hoshinup.garocedev.com:3004';   
  constructor(private http: HttpClient) { }

  calndar(date,calendar_,descripcion){
    var service="http://localhost/api/api.calendar.php";
    var url_=service+"?token=123456789&date_start="+date+"&date_end="+date+"&descripcion="+descripcion+"&calendar="+calendar_;
    let seq = this.http.get<any>(url_).map((res) => res).toPromise();
    return seq;
  }
  service(method_,postData){
    let seq = this.http.post<any>(this.url +method_, postData).map((res) => res).toPromise();
    return seq;
  }
}
